import { Component, Input, OnInit } from '@angular/core';
import { CourseService } from '@app/_services/course.service';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import * as actions from '../course-player.actions';
import * as fromCoursePlayer from '../course-player.reducer';

@Component({
  selector: 'app-page-left-button',
  templateUrl: './page-left-button.component.html'
})
export class PageLeftButtonComponent implements OnInit {
  faArrowLeft = faArrowLeft;

  @Input()
  disabled!: boolean

  @Input()
  visible!: boolean

  @Input()
  prevUnit!: boolean

  @Input()
  prevModule!: boolean

  @Input()
  prevUnitId!: number

  @Input()
  prevModuleId!: number

  constructor(private store: Store<{ coursePlayerState: fromCoursePlayer.State }>,
    private courseService: CourseService) { }

  ngOnInit(): void {
  }

  back() {
    console.log("THIS PREV UNIT", { o: this.prevUnitId });

    if (this.disabled) return;

    if ((this.prevUnit && this.prevUnitId > -1) || (this.prevModule && this.prevModuleId > -1)) {      
      const course = this.courseService.getCourseData();
      const courseId = course.courseId;
      const courseData = course.courseData;
                  
      this.prevUnitId = this.prevUnitId > -1 ? this.prevUnitId : 0;
      this.prevModuleId = this.prevModuleId > -1 ? this.prevModuleId : 0;

      let pages = [];
      let unit = courseData.entities.units[this.prevUnitId];
      let module = courseData.entities.modules[this.prevModuleId];
      
      console.log("UNIT", { unit: unit});

      for (let [key, value] of Object.entries(courseData.entities.pages)) {      
        if (value['unitId'] === this.prevUnitId) {          
          pages.push(value);
        }
      }
            
      console.log("Audio Unit", { audio: unit.audio })

      this.store.dispatch(new actions.Load(
        pages.map(o => {
          return {
            id: o.id,
            pageUrl: o.image,
            content: o.content,
            audioIndex: o.audio.length > 0 ? o.audio[0] : -1,
            isStart: o.isStart,
            isEnd: o.isEnd,
            nextModule: o.nextModule,
            nextModuleId: o.nextModuleId,
            nextUnit: o.nextUnit,
            nextUnitId: o.nextUnitId,
            prevModule: o.prevModule,
            prevModuleId: o.prevModuleId,
            prevUnit: o.prevUnit,
            prevUnitId: o.prevUnitId,
            unitId: o.unitId,
            moduleId: o.moduleId,
            audioCount: o.audioCount
          }
        }),
        courseId,
        unit.audio,       
        module.name, 
        unit.name,
        true // load last page
      ));


    }    
    else {            
      this.store.dispatch(new actions.PageLeft());
    }    
  }
}
